import { Link } from "react-router-dom";
import { MapPin, Users } from "lucide-react";
import { gbp } from "@/lib/api";

export const ClinicCard = ({ c, compact = false }) => (
  <Link to={`/clinic/${c.slug}`} data-testid={`clinic-card-${c.id}`}
    className={`group block rounded-2xl bg-card border border-border overflow-hidden lift ${compact ? "w-72 shrink-0" : ""}`}>
    <div className="relative aspect-[4/3] overflow-hidden">
      <img src={c.image} alt={c.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
      {c.booked_this_week > 0 && (
        <span className="absolute top-3 left-3 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-xs font-semibold text-primary">
          {c.booked_this_week} booked
        </span>
      )}
      <span className="absolute bottom-3 left-3 rounded-full bg-primary/90 px-3 py-1 text-xs font-medium text-white">{c.discipline_name}</span>
    </div>
    <div className="p-4 space-y-1.5">
      <h3 className="font-display font-bold text-base leading-snug group-hover:text-primary transition-colors">{c.name}</h3>
      <div className="flex items-center gap-3 text-xs text-muted-foreground">
        <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" />{c.city}</span>
        <span className="flex items-center gap-1"><Users className="h-3.5 w-3.5" />{c.practitioner_count} practitioners</span>
      </div>
      {c.min_price != null && <p className="text-sm"><span className="text-muted-foreground">from </span><span className="font-semibold">{gbp(c.min_price)}</span></p>}
    </div>
  </Link>
);
